import { combineReducers } from 'redux'
import fakSettings from './fak.settings.reducer'

const nextReducers = combineReducers({
  fakSettings
})

export default nextReducers
